import React from 'react';
import Select from 'react-select';
import { displayStatusLabel } from 'src/utils/serviceRequestStatus/displayStatusLabel';
import './ModernizedServiceRequestActions.scss';

interface Props {
  statuses: any[];
  selectedStatusId: string;
  currentStatusName: string;
  assignedToName?: string;
  saving: boolean;
  onStatusChange: (id: string) => void;
}

const ALLOWED_STATUSES = new Set(['En Route', 'On Hold', 'In Progress', 'Resolved', 'Under Review']);

const ModernizedServiceRequestActions: React.FC<Props> = ({
  statuses,
  selectedStatusId,
  currentStatusName,
  assignedToName,
  saving,
  onStatusChange,
}) => {
  const statusOptions: any = statuses
    .filter((s: any) => ALLOWED_STATUSES.has(s.name))
    .map((s: any) => ({
      label: displayStatusLabel(s.name, s.customLabel),
      value: s.id,
    }));

  return (
    <div className="offline-sr-actions">
      {currentStatusName === 'Assigned' && (
        <p className="offline-sr-actions-assigned-notice">
          This service request has been assigned to you{assignedToName ? ` — ${assignedToName}` : ''}.
          Select a status below when you're ready to begin work.{' '}
        </p>
      )}
      <h3 className="offline-sr-actions-title">Update Status</h3>
      <div className="offline-sr-actions-desktop">
        <Select
          value={
            statusOptions.find((o: any) => o.value === selectedStatusId) ?? null
          }
          onChange={(option: any) => option && onStatusChange(option.value)}
          options={statusOptions}
          placeholder="Select a status"
          isDisabled={saving}
        />
      </div>
      <select
        className="offline-sr-actions-native"
        value={selectedStatusId}
        onChange={(e) => onStatusChange(e.target.value)}
        disabled={saving}
      >
        <option value="" disabled>
          Select a status
        </option>
        {statusOptions.map((o: any) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ModernizedServiceRequestActions;
